/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Link as ReactLink } from 'react-router-dom';

import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlGenerator } from '../../contexts/RoutesContext';
import Label from './Label';

const propTypes = {
    href: PropTypes.string,
    route: PropTypes.string,
    routeParams: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    external: PropTypes.bool,
    target: PropTypes.string,
    children: AppPropTypes.label,
    rel: PropTypes.string,
    onClick: PropTypes.func,
    scrollTop: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    href: null,
    route: null,
    routeParams: null,
    external: false,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: null,
    scrollTop: true,
    children: null,
    className: null,
};

const Link = ({
    href,
    route,
    routeParams,
    external,
    children,
    target,
    rel,
    onClick,
    scrollTop,
    className,
    ...props
}) => {
    const url = useUrlGenerator();

    let link = null;
    if (route !== null && routeParams !== null) {
        link = url(route, routeParams);
    } else if (route !== null) {
        link = url(route);
    } else if (href !== null) {
        link = href;
    }

    if (link === null) {
        return (
            <span className={className}>
                <Label>{children}</Label>
            </span>
        );
    }

    const scroll = useCallback(() => {
        window.scroll({
            top: 0,
            // behavior: 'smooth',
        });
    }, []);

    const onClickLink = useCallback(
        (...args) => {
            if (scrollTop && !external) {
                if (onClick !== null) {
                    scroll();
                    onClick(...args);
                } else {
                    scroll();
                }
            } else if (onClick !== null) {
                onClick(...args);
            }
        },
        [scrollTop, external, onClick],
    );

    return external ? (
        <a
            className={className}
            href={href}
            target={target}
            rel={rel}
            onClick={onClickLink}
            {...props}
        >
            <Label>{children}</Label>
        </a>
    ) : (
        <ReactLink className={className} to={href} onClick={onClickLink} {...props}>
            <Label>{children}</Label>
        </ReactLink>
    );
};

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export default Link;
